import { h } from 'preact';
import { useStore } from 'src/hooks';
import { ROUTE_STUDIO } from 'src/common/routes';
import * as styles from './styles.less';

const Header = () => {
    const ctx = useStore();
    const title = ctx.layout.title.value;
    const subtitle = ctx.layout.subtitle.value;
    const extraTitle = ctx.layout.extraTitle.value;

    const displayExtraTitle = [ROUTE_STUDIO.REVENUE_DETAILS, ROUTE_STUDIO.PAYMENTS_LIST].includes(window.location.pathname as ROUTE_STUDIO);

    return (
        <header class={styles.header}>
            <div class={styles.header__top} id="top" />
            <div class={styles.header__slogan}>
                <div class={styles.header__slogan_rside}>HomeCams</div>
                <div class={styles.header__logo} />
                <div class={styles.header__slogan_lside}>from around the world</div>
            </div>
            {title && (
                <div class={styles.header__title_container}>
                    <div class={styles.header__title_wrapper}>
                        <h1 class={styles.header__title}>{title}</h1>
                        {displayExtraTitle && extraTitle && <h2 class={styles.header__extra_title}>{extraTitle}</h2>}
                    </div>
                    {subtitle && <p class={styles.header__subtitle}>{subtitle}</p>}
                </div>
            )}
        </header>
    );
};

export default Header;
